import type { Locale } from './typings';

const jpLocale: Locale = {
  nick: 'ニックネーム',
  nickError: '3バイト以上のニックネームをご入力ください.',
  mail: 'メールアドレス',
  mailError: 'メールアドレスをご確認ください.',
  link: 'サイト(http://)',
  placeholder: 'ここにコメント',
  sofa: 'コメントしましょう~',
  submit: '提出する',
  reply: '返信する',
  cancelReply: 'キャンセル',
  comment: 'コメント',
  more: 'さらに読み込む...',
  preview: 'プレビュー',
  uploadImage: '画像をアップロード',
  emoji: '絵文字',
  seconds: '秒前',
  minutes: '分前',
  hours: '時間前',
  days: '日前',
  now: 'たっだ今',
  uploading: 'アップロード',
  login: 'ログインする',
  logout: 'ログアウト',
  admin: '管理者',
  word: 'ワード',
  wordHint:
    'コメントは $0 から $1 ワードの間でなければなりません!\n 現在の単語番号: $2',
};

export default jpLocale;
